import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function SummaryView({ apiBase, loading, setLoading, error, setError }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${apiBase}/analytics/summary`);
      setData(response.data);
    } catch (err) {
      setError('Failed to load summary data: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading data...</div>;
  }

  if (!data) {
    return null;
  }

  const outcomeData = {
    labels: ['Responded', 'Voicemail', 'No Response'],
    datasets: [{
      data: [
        data.calls_with_response,
        data.calls_to_voicemail,
        data.total_calls - data.calls_with_response - data.calls_to_voicemail
      ],
      backgroundColor: ['#48bb78', '#ed8936', '#cbd5e0']
    }]
  };

  const paymentData = {
    labels: ['Willing to Pay', 'Not Willing'],
    datasets: [{
      data: [
        data.willing_to_pay_count,
        data.total_calls - data.willing_to_pay_count
      ],
      backgroundColor: ['#667eea', '#cbd5e0']
    }]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'bottom'
      }
    }
  };

  return (
    <>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Calls</h3>
          <div className="value">{data.total_calls.toLocaleString()}</div>
          <div className="subvalue">All time</div>
        </div>
        <div className="stat-card">
          <h3>Total Credits Used</h3>
          <div className="value">{data.total_credits_used.toLocaleString()}</div>
          <div className="subvalue">ElevenLabs credits</div>
        </div>
        <div className="stat-card">
          <h3>Total Cost</h3>
          <div className="value cost">${(data.total_cost / 100).toFixed(2)}</div>
          <div className="subvalue">Your cost from ElevenLabs</div>
        </div>
        <div className="stat-card">
          <h3>Avg Cost/Call</h3>
          <div className="value">${(data.average_cost_per_call / 100).toFixed(2)}</div>
          <div className="subvalue">{data.average_credits_per_call.toFixed(0)} credits avg</div>
        </div>
        <div className="stat-card">
          <h3>Response Rate</h3>
          <div className="value">{((data.calls_with_response / data.total_calls) * 100).toFixed(1)}%</div>
          <div className="subvalue">{data.calls_with_response} calls responded</div>
        </div>
        <div className="stat-card">
          <h3>Voicemail Rate</h3>
          <div className="value">{((data.calls_to_voicemail / data.total_calls) * 100).toFixed(1)}%</div>
          <div className="subvalue">{data.calls_to_voicemail} to voicemail</div>
        </div>
        <div className="stat-card">
          <h3>Willing to Pay</h3>
          <div className="value profit">{data.willing_to_pay_count}</div>
          <div className="subvalue">{((data.willing_to_pay_count / data.total_calls) * 100).toFixed(1)}% conversion</div>
        </div>
      </div>

      <div className="chart-grid">
        <div className="chart-container">
          <h2>Call Outcomes</h2>
          <Doughnut data={outcomeData} options={chartOptions} />
        </div>
        <div className="chart-container">
          <h2>Payment Willingness</h2>
          <Doughnut data={paymentData} options={chartOptions} />
        </div>
      </div>
    </>
  );
}

export default SummaryView;

